import { attachedFileFragment } from '@reconcept-platform/shared/data-access';
import { gql } from 'apollo-angular';
import { workspaceUserItemFragment } from '../user/user.fragments';

export const commentDetailFragment = gql`
  fragment CommentDetailFragment on CardComment {
    card {
      ... on GoalCard {
        id
      }
      ... on EventCard {
        id
      }
    }
    commentJsonContent
    creator {
      ...WorkspaceUserItem
    }
    id
    updatedAt
    createdAt
    attachedFiles {
      ...AttachedFile
    }
  }
  ${workspaceUserItemFragment}
  ${attachedFileFragment}
`;
